export default {  
  user: null,
}